/**
 * Serializable check configuration that allows Date objects in Redux state
 * This extends the default Redux Toolkit serializable check to accept Date instances
 */
export const dateSerializableConfig = {
  isSerializable: (value: any): boolean => {
    // Allow Date objects specifically
    if (value instanceof Date) {
      return true;
    }

    // Allow primitives
    if (
      typeof value === "string" ||
      typeof value === "number" ||
      typeof value === "boolean" ||
      value === null ||
      value === undefined
    ) {
      return true;
    }

    // Allow plain objects and arrays
    if (
      Array.isArray(value) ||
      (typeof value === "object" && value.constructor === Object)
    ) {
      return true;
    }

    return false;
  },
};

/**
 * Alternative approach: Configure specific paths to ignore
 * Use this if you want to be more explicit about which Date fields to allow
 */
export const dateFieldsIgnoreConfig = {
  // Ignore specific action types that contain dates
  ignoredActions: [
    "sessions/setCurrentSession",
    "sessions/fetchSessionById/fulfilled",
    "sessions/createSession/fulfilled",
    "sessions/updateSession/fulfilled",
  ],

  // Ignore specific paths in actions that contain dates
  ignoredActionsPaths: [
    "payload.dateStart",
    "payload.dateCreated",
    "payload.dateModified",
    "payload.recurrenceDateEnd",
  ],

  // Ignore specific paths in state that contain dates
  ignoredPaths: [
    "sessions.currentSession.dateStart",
    "sessions.currentSession.dateCreated",
    "sessions.currentSession.dateModified",
    "sessions.currentSession.recurrenceDateEnd",
    "sessions.sessions",
  ],
};
